<!-- Componente para isolar ao máximo os Beans do resto do código, pois são utilitários deprecados!! -->
<template>
  <div
    class="text-center"
    v-if="SearchDatabaseClassType && beans.searchDatabaseExecutorBean ||
          SearchDataBaseClassType && beans.searchDataBaseExecutorBean ||
          ConvertDatabaseResultClassType && beans.convertDatabaseResultExecutorBean ||
          AuthenticationClassType && beans.wsAuthenticationBean ||
          AuthorizationClassType && beans.wsAuthorizationBean ||
          SqlUpdateBeforeWsCallClassType && beans.sqlUpdateBeforeWsCallExecutorBean ||
          SqlUpdateAfterWsCallSuccessClassType && beans.sqlUpdateAfterWsCallSuccessExecutorBean ||
          SqlUpdateAfterWsCallErrorClassType && beans.sqlUpdateAfterWsCallErrorExecutorBean ||
          WsCallClassType && beans.wsCallExecutorBean ||
          GenerateXmlPayloadClassType && beans.generateXmlPayloadExecutorBean ||
          ProcessCallWsSoapClassType && beans.processCallWsSoapExecutorBean ||
          ProcessWsReturnClassType && beans.processWsReturnExecutorBean ||
          ReturnErrorMessageClassType && beans.returnErrorMessageExecutorBean"
  >
    <v-dialog v-model="dialog" width="500" >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark v-bind="attrs"
          v-on="on"
          v-text="label"
        />
      </template>

      <v-card>
        <v-card-title class="title">
          <h3>Configuração de Beans</h3>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <BeanSelect
            v-if="SearchDataBaseClassType"
            :label="$t('keywords.bean.query')"
            v-model="beans.searchDataBaseExecutorBean"
            :classtype="SearchDatabaseClassType"
          />
          <BeanSelect
            v-if="SearchDatabaseClassType"
            :label="$t('keywords.bean.query')"
            v-model="beans.searchDatabaseExecutorBean"
            :classtype="SearchDatabaseClassType"
          />
          <BeanSelect
            v-if="ConvertDatabaseResultClassType"
            :label="$t('keywords.bean.conversion')"
            v-model="beans.convertDatabaseResultExecutorBean"
            :classtype="ConvertDatabaseResultClassType"
          />
          <!---->
          <BeanSelect
            v-if="AuthenticationClassType"
            :label="$t('keywords.bean.authentication')"
            v-model="beans.wsAuthenticationBean"
            :classtype="AuthenticationClassType"
          />
          <BeanSelect
            v-if="AuthorizationClassType"
            :label="$t('keywords.bean.authorization')"
            v-model="beans.wsAuthorizationBean"
            :classtype="AuthorizationClassType"
          />
          <!---->
          <BeanSelect
            v-if="SqlUpdateBeforeWsCallClassType"
            :label="$t('keywords.bean.update')"
            v-model="beans.sqlUpdateBeforeWsCallExecutorBean"
            :classtype="SqlUpdateBeforeWsCallClassType"
          />
          <BeanSelect
            v-if="SqlUpdateAfterWsCallSuccessClassType"
            :label="$t('keywords.bean.update_at.success')"
            v-model="beans.sqlUpdateAfterWsCallSuccessExecutorBean"
            :classtype="SqlUpdateAfterWsCallSuccessClassType"
          />
          <BeanSelect
            v-if="SqlUpdateAfterWsCallErrorClassType"
            :label="$t('keywords.bean.update_at.error')"
            v-model="beans.sqlUpdateAfterWsCallErrorExecutorBean"
            :classtype="SqlUpdateAfterWsCallErrorClassType"
          />
          <BeanSelect
            v-if="WsCallClassType"
            :label="$t('keywords.bean.execution')"
            v-model="beans.wsCallExecutorBean"
            :classtype="WsCallClassType"
          />
          <BeanSelect
            v-if="GenerateXmlPayloadClassType"
            :label="$t('keywords.bean.xml')"
            v-model="beans.generateXmlPayloadExecutorBean"
            :classtype="GenerateXmlPayloadClassType"
          />
          <BeanSelect
            v-if="ProcessCallWsSoapClassType"
            :label="$t('keywords.bean.soap')"
            v-model="beans.processCallWsSoapExecutorBean"
            :classtype="ProcessCallWsSoapClassType"
          />
          <BeanSelect
            v-if="ProcessWsReturnClassType"
            :label="$t('keywords.bean.update_at.success')"
            v-model="beans.processWsReturnExecutorBean"
            :classtype="ProcessWsReturnClassType"
          />
          <BeanSelect
            v-if="ReturnErrorMessageClassType"
            :label="$t('keywords.bean.update_at.error')"
            v-model="beans.returnErrorMessageExecutorBean"
            :classtype="ReturnErrorMessageClassType"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BeanSelect from './BeanSelect.vue'

export default {
  name: 'BeansConfiguration',

  components: { BeanSelect },

  data: () => ({
    dialog: false
  }),

  props: {
    label: {
      type: String,
      default: 'Configurar Beans'
    },
    SearchDataBaseClassType: String,
    SearchDatabaseClassType: String,
    ConvertDatabaseResultClassType: String,
    AuthenticationClassType: String,
    AuthorizationClassType: String,
    SqlUpdateBeforeWsCallClassType: String,
    SqlUpdateAfterWsCallSuccessClassType: String,
    SqlUpdateAfterWsCallErrorClassType: String,
    WsCallClassType: String,
    GenerateXmlPayloadClassType: String,
    ProcessCallWsSoapClassType: String,
    ProcessWsReturnClassType: String,
    ReturnErrorMessageClassType: String,
    beans: Object
  },

  model: {
    prop: 'beans',
    event: 'change'
  }

}
</script>
<style scoped>
  .title {
    display:flex;
    flex-direction:column;
    font-size:12px;
    color: #009280;
  }
</style>
